import { Injectable } from "@angular/core";

import {Panel, VisibilityLogicDefinition, VisibilityLogicTriggeringStatus} from '../../common/metadata/metadata.model';
import {Record} from '../../common/record/record.model';
import {ViewMode} from '../../common/views/view.model';
import { BaseActionManager } from "../../services/actions/base-action-manager.service";

import { PanelVisibilityLogicActionData } from "./panel-logic-visibility.action";

@Injectable({
  providedIn: 'root'
})
export class PanelLogicVisibilityManager extends BaseActionManager<PanelVisibilityLogicActionData> {
  public runLogic(panel: Panel, record: Record, mode: ViewMode, triggeringDisplay: [boolean, boolean]): void {
    if(!panel.meta.visibilityLogic) {
      return
    }

    const modeActions: VisibilityLogicDefinition[] = this.parseModeActions(Object.values(panel.meta.visibilityLogic), mode)

    if(!modeActions.length) {
      return;
    }

    const triggeringStatus = this.getTriggeringStatus(triggeringDisplay)
    const data: PanelVisibilityLogicActionData = this.buildActionData(panel, record, triggeringStatus)

    modeActions.forEach((action) => {
      if(!action.trigger || action.trigger === triggeringStatus) {
        this.run(action, mode, data);
      }
    })
  }

  protected parseModeActions(logics: VisibilityLogicDefinition[], mode: ViewMode): VisibilityLogicDefinition[] {
    return logics.filter(logic => {
      const allowedModes = logic['modes'] ?? [];
      return allowedModes.includes(mode) && this.actions[mode]?.[logic.key]?.modes.includes(mode);
    })
  }

  protected buildActionData(panel: Panel, record: Record, triggeringStatus: VisibilityLogicTriggeringStatus): PanelVisibilityLogicActionData {
    return {
      panel,
      context: {
        record,
        triggeringStatus
      }
    };
  }

  protected getTriggeringStatus(triggeringDisplay: [boolean, boolean]): VisibilityLogicTriggeringStatus {
    if(triggeringDisplay[0] === true && triggeringDisplay[1] === false) {
      return 'hide'
    }

    return 'show'
  }
}
